module.exports = __webpack_public_path__ + "static/media/pizza.3384e9cb.svg";